import React from 'react';

const CustomFieldFormModal = React.lazy(() => import('../components/FormModal'));
const customFieldModalRegistry = {
    crm_customFieldId: CustomFieldFormModal
};
export default customFieldModalRegistry;
